import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ui-info-box',
  templateUrl: 'ui-info-box.component.html',
  styleUrls: ['ui-info-box.component.scss'],
  standalone: false
})
export class UIInfoBoxComponent {
  @Input() status: 'warning' | 'info' | 'error' | 'success' | 'loading';

  getIcon(): string {
    switch (this.status) {
      case 'warning':
        return 'icon-i-warning';
      case 'info':
        return 'icon-i-info';
      case 'error':
        return 'icon-i-close-circle';
      case 'success':
        return 'icon-i-checkmark-circle';
      case 'loading':
        return 'icon-i-windmill';
      default:
        return 'icon-i-info';
    }
  }
}
